import { Card, CardBody, Col, Row } from "reactstrap";
import { H4, SVG } from "../../../../AbstractElements";
import WidgetsWithChart from "./WidgetsWithChart";
import CountUp from "react-countup";
import { SMALL_WIDGET_DATA } from "../../../../Data/Widgets/GeneralWidgets";

const SmallWidgets = () => {
  return (
    <Col xxl="5" xl="8" className="box-col-12">
      <Row className="g-sm-3 height-equal-2 widget-charts">
        {SMALL_WIDGET_DATA.map((data, i) => (
          <Col sm="6" className="box-col-3" key={i}>
            <Card className={`small-widget mb-sm-0`}>
              <CardBody className={data.color}>
                <span className="f-light">{data.title}</span>
                <div className="d-flex align-items-end gap-1">
                  <H4>
                    <CountUp suffix={data.suffix ? data.suffix : ""} prefix={data.prefix ? data.prefix : ""} duration={5} separator="," end={data.total}/>
                  </H4>
                  <span className={`font-${data.color} f-12 f-w-500`}>
                    <i className={`icon-arrow-${data.gros < 50 ? "down" : "up"}`}/>
                    <span> {data.gros < 50 ? "-" : "+"} {data.gros}%</span>
                  </span>
                </div>
                <div className="bg-gradient">
                  <SVG iconId={data.icon} className="stroke-icon svg-fill"/>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
        <WidgetsWithChart />
      </Row>
    </Col>
  );
};

export default SmallWidgets;
